import { createContext } from 'react';

const useProductSamplingv2Context = createContext();
export default useProductSamplingv2Context;
